import { useEffect, useRef } from 'react';

const useInterval = (callback, delay, dependencies = []) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback, ...dependencies]);

    useEffect(() => {
        if (delay === null) {
            return;
        }

        const tick = () => {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };

        const intervalId = setInterval(tick, delay);
        return () => {
            clearInterval(intervalId);
        }
    }, [delay, ...dependencies]);
};

export default useInterval;
